import {
  Combobox,
  ComboboxInput,
  ComboboxContent,
  ComboboxList,
  ComboboxItem,
  ComboboxEmpty,
} from '@hydrodigital/combobox';
import type { ComboboxOption } from '@hydrodigital/combobox';
import { forwardRef, useImperativeHandle, useState } from 'react';
import useLocation from '../../hooks/useLocation';

const SelectLocation = forwardRef(
  (
    {
      userId,
      onSelect,
      mode = 'ByUser',
      className = '',
    }: {
      userId: string;
      onSelect: Function;
      mode?: 'ByUser' | 'ByCountry';
      className?: string;
    },
    ref,
  ) => {
    const [selectedValue, setSelectedValue] = useState<string | undefined>(undefined);
    const { locations } = useLocation({
      mode,
      userId,
    });

    function parseLocations(locations: any[]): ComboboxOption[] {
      return locations.map((location) => ({
        value: String(location.locationId),
        label: location.locationName,
        children: location.childLocations
          ? parseLocations(location.childLocations)
          : [],
        disabled: !location.canShowLocation,
      }));
    }

    useImperativeHandle(ref, () => ({
      setValue: (value: any) => {
        setSelectedValue(value !== null && value !== undefined ? String(value) : undefined);
      },
    }));

    const items = parseLocations(locations);

    return (
      <Combobox
        items={items}
        value={selectedValue}
        onValueChange={(val) => {
          setSelectedValue(String(val));
          onSelect(val);
        }}
        onClear={() => {
          setSelectedValue(undefined);
          onSelect(null);
        }}
        size="small"
        persistKey="app/select-location"
      >
        <ComboboxInput placeholder="Select Location" className={className} />
        <ComboboxContent>
          <ComboboxEmpty>No locations found.</ComboboxEmpty>
          <ComboboxList>
            {(item) => (
              <ComboboxItem key={item.value} value={item}>
                {item.label}
              </ComboboxItem>
            )}
          </ComboboxList>
        </ComboboxContent>
      </Combobox>
    );
  },
);

export default SelectLocation;
